import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { getMeterFillStyles, meterTrackStyles, percentCellStyles } from '../../Construction.styles';
import { getClampedPercent } from '../../Construction.utils';

const PercentMeter = ({ percent, isOverBudget = false }) => {
  const clampedPercent = getClampedPercent(percent);

  return (
    <Box sx={percentCellStyles}>
      <Box sx={meterTrackStyles}>
        <Box sx={getMeterFillStyles({ percent: clampedPercent, isOverBudget })} />
      </Box>
      <Typography variant="regular14">{`${percent ?? 0}%`}</Typography>
    </Box>
  );
};

PercentMeter.propTypes = {
  percent: PropTypes.number,
  isOverBudget: PropTypes.bool,
};

export default memo(PercentMeter);
